import { z } from "zod";

/**
 * Keys auth — API key managed externally (e.g. by Pipedream for CUSTOM_MANIFEST tools).
 * No runtime handling in Nexus — getCredentials() falls through with empty headers.
 * Requests succeed only if the downstream API accepts unauthenticated calls or if
 * the key is injected by a proxy layer (e.g. Pipedream's own infrastructure).
 */
export const CustomManifestKeysSchema = z.object({
  type: z.literal("keys")
});

export type CustomManifestKeys = z.infer<typeof CustomManifestKeysSchema>;
